module.exports = __webpack_public_path__ + "img/dateselect.c7715c5a.png";